module.exports = __webpack_public_path__ + "static/introductionSlider3.0df87a75.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/introductionSlider3.jpg
// module id = 405
// module chunks = 35783957827783